import type { Deployment, ServiceOperation, ServiceOverview } from '../api'

export function deriveOverviewOperationFromLifecycleEvent(
  overview: ServiceOverview | null,
  payload: Record<string, any>,
): ServiceOperation | null {
  if (!overview || !payload.kind) return null
  return {
    kind: payload.kind,
    status: payload.status ?? 'running',
    phase: payload.phase ?? '',
    deployment_id: payload.deployment_id,
    error: payload.error,
    started_at: payload.started_at,
    ended_at: payload.ended_at,
  }
}

export function deriveOverviewOperationFromDeployPhase(
  overview: ServiceOverview | null,
  deployments: Deployment[],
  payload: Record<string, any>,
): ServiceOperation | null {
  if (!overview || !payload.deployment_id || !payload.phase) return null
  const match = deployments.find(d => d.id === payload.deployment_id)
  if (!match) return null
  return {
    kind: match.triggered_by === 'rollback' ? 'rollback' : 'deploy',
    status: 'running',
    phase: payload.phase,
    deployment_id: payload.deployment_id,
    started_at: match.started_at,
    ended_at: match.finished_at,
    error: match.error,
  }
}
